module.exports = __webpack_public_path__ + "img/e.a04d914a.png";